import React, {useEffect, useState} from "react";

import './stop-recording-modal.scss'
import {Modal, NumberInput} from "@carbon/react";
import {ADD, useToastContext} from "../Toast";
import {useRecoilValue} from "recoil";
import {grpcCustomerServiceSelector} from "../../state/grpc";
import PropTypes from "prop-types";

const StopRecordingModal = ({isOpen, setOpen, recording, updateRecording}) => {
  const customersService = useRecoilValue(grpcCustomerServiceSelector)
  const {toastDispatch} = useToastContext();
  const [recSeconds, setRecSeconds] = useState(0)

  useEffect(() => {
    if (!recording) {
      return
    }
    setRecSeconds(recording.durationseconds)
  }, [recording]);

  const computeRecordingMinutes = (seconds) => {
    if (!seconds || seconds === 0) {
      return 5
    }
    return Math.round((Math.ceil(seconds / 5) * 5) / 60)
  }

  return (
    <Modal
      open={isOpen}
      modalHeading="Ferma la rendicontazione"
      modalLabel="Rendicontazione"
      danger={true}
      primaryButtonText="Procedi"
      secondaryButtonText="Annulla"
      onRequestSubmit={() => {
        const req = new proto.api.StopRecordingRequest()
        req.setId(recording.id)
        req.setDurationseconds(`${recSeconds}`)
        customersService.stopRecording(req, null, (err, resp) => {
          if (err != null) {
            console.error(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile fermare la rendicontazione. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione avvenuta con successo",
                content: `Rendicontazione chiusa con successo`,
                kind: "success"
              }
            })
            updateRecording(null)
          }
          setOpen(false)
        })
      }}
      onRequestClose={() => {
        setOpen(false)
      }}>
      <p style={{marginBottom: '1rem'}}>
        Stai fermando la rendicontazione per il cliente {recording.systemName}. Al momento, risultano rendicontati
        {` ${computeRecordingMinutes(recording.durationseconds)}`} minuti. Hai la possibilità di modificare il valore dei
        minuti nell'input messo a disposizione qui sotto. Altrimenti, se risulta tutto corretto, non devi fare altro
        che proseguire.
      </p>
      <br/>
      <NumberInput
        id="recording-duration"
        label="Minuti da rendicontare"
        min={5}
        data-modal-primary-focus
        style={{marginBottom: 'rem'}}
        value={computeRecordingMinutes(recSeconds)}
        onChange={(event, { value, direction }) => {
          setRecSeconds(value * 60)
        }}
      />
    </Modal>
  )
}

StopRecordingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  recording: PropTypes.object.isRequired,
}

export default StopRecordingModal